import angular from 'angular';

class SessionService {
    constructor($sessionStorage, sessionStorageConstants) {
        this.$sessionStorage = $sessionStorage;
        this.sessionStorageConstants = sessionStorageConstants;
    }

    getSessionType() {
        return this.$sessionStorage[this.sessionStorageConstants.sessionType];
    }
}

angular.module('shared').service('sessionService', SessionService);



// WEBPACK FOOTER //
// ./modules/shared/services/session/session.service.js